export const MODEL_3D_EXTENSIONS = ['stl', 'ply', 'obj'];

export const fileExtension = (name) => {
    const base = String(name ?? '').split(/[\\/]/).pop();
    const dot = base.lastIndexOf('.');
    return dot > 0 ? base.slice(dot + 1).toLowerCase() : '';
};

/** Extensions the in-app 3D viewer can open (zip archives are scanned for 3D files). */
export const isModel3DPreviewable = (extension) => {
    const ext = String(extension ?? '').toLowerCase();
    return ext === 'zip' || MODEL_3D_EXTENSIONS.includes(ext);
};
